<template>
<div class="attribute-icon">
  <A01 :size="size" v-if="attributeKey === 'A_01'"></A01>
  <SA0101 :size="size" v-if="attributeKey === 'SA_01_01'"></SA0101>
  <SA0102 :size="size" v-if="attributeKey === 'SA_01_02'"></SA0102>
  <SA0103 :size="size" v-if="attributeKey === 'SA_01_03'"></SA0103>
  <SA0104 :size="size" v-if="attributeKey === 'SA_01_04'"></SA0104>
  <A02 :size="size" v-if="attributeKey === 'A_02'"></A02>
  <SA0201 :size="size" v-if="attributeKey === 'SA_02_01'"></SA0201>
  <SA0202 :size="size" v-if="attributeKey === 'SA_02_02'"></SA0202>
  <SA0203 :size="size" v-if="attributeKey === 'SA_02_03'"></SA0203>
  <SC0202a :size="size" v-if="attributeKey === 'SC_02_02_a'"></SC0202a>
  <SC0202b :size="size" v-if="attributeKey === 'SC_02_02_b'"></SC0202b>
  <SC0202c :size="size" v-if="attributeKey === 'SC_02_02_c'"></SC0202c>
  <SC0202d :size="size" v-if="attributeKey === 'SC_02_02_d'"></SC0202d>
  <SC0202e :size="size" v-if="attributeKey === 'SC_02_02_e'"></SC0202e>
  <SC0203a :size="size" v-if="attributeKey === 'SC_02_03_a'"></SC0203a>
  <SC0203b :size="size" v-if="attributeKey === 'SC_02_03_b'"></SC0203b>
  <SC0203c :size="size" v-if="attributeKey === 'SC_02_03_c'"></SC0203c>
  <A03 :size="size" v-if="attributeKey === 'A_03'"></A03>
  <SA0301 :size="size" v-if="attributeKey === 'SA_03_01'"></SA0301>
  <SA0302 :size="size" v-if="attributeKey === 'SA_03_02'"></SA0302>
  <SA0303 :size="size" v-if="attributeKey === 'SA_03_03'"></SA0303>
  <A04 :size="size" v-if="attributeKey === 'A_04'"></A04>
  <SA0401 :size="size" v-if="attributeKey === 'SA_04_01'"></SA0401>
  <SA0402 :size="size" v-if="attributeKey === 'SA_04_02'"></SA0402>
  <A05 :size="size" v-if="attributeKey === 'A_05'"></A05>
  <SA0501 :size="size" v-if="attributeKey === 'SA_05_01'"></SA0501>
  <SA0502 :size="size" v-if="attributeKey === 'SA_05_02'"></SA0502>
  <SA0503 :size="size" v-if="attributeKey === 'SA_05_03'"></SA0503>
  <SA0504 :size="size" v-if="attributeKey === 'SA_05_04'"></SA0504>
</div>
</template>

<script>
import A01 from './attributes/A_01.vue'
import A02 from './attributes/A_02.vue'
import A03 from './attributes/A_03.vue'
import A04 from './attributes/A_04.vue'
import A05 from './attributes/A_05.vue'
import SA0101 from './attributes/SA_01_01.vue'
import SA0102 from './attributes/SA_01_02.vue'
import SA0103 from './attributes/SA_01_03.vue'
import SA0104 from './attributes/SA_01_04.vue'
import SA0201 from './attributes/SA_02_01.vue'
import SA0202 from './attributes/SA_02_02.vue'
import SA0203 from './attributes/SA_02_03.vue'
import SA0301 from './attributes/SA_03_01.vue'
import SA0302 from './attributes/SA_03_02.vue'
import SA0303 from './attributes/SA_03_03.vue'
import SA0401 from './attributes/SA_04_01.vue'
import SA0402 from './attributes/SA_04_02.vue'
import SC0202a from './attributes/SC_02_02_a.vue'
import SC0202b from './attributes/SC_02_02_b.vue'
import SC0202c from './attributes/SC_02_02_c.vue'
import SC0202d from './attributes/SC_02_02_d.vue'
import SC0202e from './attributes/SC_02_02_e.vue'
import SC0203a from './attributes/SC_02_03_a.vue'
import SC0203b from './attributes/SC_02_03_b.vue'
import SC0203c from './attributes/SC_02_03_c.vue'
import SA0501 from './attributes/SA_05_01.vue'
import SA0502 from './attributes/SA_05_02.vue'
import SA0503 from './attributes/SA_05_03.vue'
import SA0504 from './attributes/SA_05_04.vue'

export default {
  'name': 'AttributeIcon',
  components: {
    A01,
    SA0101,
    SA0102,
    SA0103,
    SA0104,
    A02,
    SA0201,
    SA0202,
    SA0203,
    SC0202a,
    SC0202b,
    SC0202c,
    SC0202d,
    SC0202e,
    SC0203a,
    SC0203b,
    SC0203c,
    A03,
    SA0301,
    SA0302,
    SA0303,
    A04,
    SA0401,
    SA0402,
    A05,
    SA0501,
    SA0502,
    SA0503,
    SA0504
  },
  'props': {
    'size': {
      type: Number,
      default: 40
    },
    'attributeKey': {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/AttributeIcon.vue